import React, { useEffect, useState } from "react";
import {
    useGetAllServiceDataQuery,
    useGetSubServiceOnIdBasisDataQuery,
} from "../../Services/vehicle/Vehicle";
import "./cart.scss";
import { useNavigate } from "react-router-dom";

interface IPROPS {
    checkoutServices: any;
    setCurrentStep: any;
    setSelectedSubServices: any;
    selectedSubServices: any;
    setServicesWithSelections: any;
    servicesWithSelections: any;
    setConfirmButtonClicked: any;
}

const Cart: React.FC<IPROPS> = ({
    setConfirmButtonClicked,
    setSelectedSubServices,
    selectedSubServices,
    setCurrentStep,
    setServicesWithSelections,
    servicesWithSelections,
}) => {
    const [subServiceData, setSubServiceData] = useState([]);
    const [services, setServices] = useState([]);
    const [serviceId, setServiceId] = useState("");
    // const [servicesWithSelections, setServicesWithSelections] = useState([]);
    console.log(selectedSubServices, "cscdscsdcdsc");
    const { data: subService } = useGetSubServiceOnIdBasisDataQuery(serviceId);
    const { data: serviceData } = useGetAllServiceDataQuery({});

    const navigate = useNavigate()

    useEffect(() => {
        if (subService) {
            setSubServiceData(subService);
        }
    }, [subService]);

    useEffect(() => {
        if (serviceData) {
            setServices(serviceData);
        }
    }, [serviceData]);

    const [expandedServices, setExpandedServices] = useState({});

    // State to track selected sub-services (multi-select)
    // const [selectedSubServices, setSelectedSubServices] = useState([]);

    // Function to toggle service expansion
    const toggleService = (serviceId) => {
        setServiceId(serviceId);
        setExpandedServices((prev) => {
            // If already expanded, collapse it
            if (prev[serviceId]) {
                return {};
            } else {
                // Collapse all others and expand the new one
                return { [serviceId]: true };
            }
        });
    };

    // Function to handle sub-service selection
    const toggleSubService = (subServiceId) => {
        const subService = subServiceData.find(
            (sub) => sub.id === subServiceId?.id
        );
        const serviceId = subService?.service_type.id;

        setSelectedSubServices((prev) => {
            let newSelected;
            if (prev.includes(subServiceId?.id)) {
                newSelected = prev.filter((id) => id !== subServiceId?.id);
            } else {
                newSelected = [...prev, subServiceId?.id];
            }

            // Update services with selections
            const serviceSubServices = getSubServicesForService(serviceId);
            const serviceHasSelections = serviceSubServices.some((sub) =>
                newSelected.includes(sub.id)
            );

            setServicesWithSelections((prevServices) => {
                if (serviceHasSelections) {
                    return prevServices.includes(serviceId)
                        ? prevServices
                        : [...prevServices, serviceId];
                } else {
                    return prevServices.filter((id) => id !== serviceId);
                }
            });

            return newSelected;
        });
    };

    // Function to get sub-services for a specific service
    const getSubServicesForService = (serviceId) => {
        return subServiceData.filter(
            (subService) => subService.service_type.id === serviceId
        );
    };

    const nextButtonHandler = () => {
        if (!selectedSubServices.length) {
            return;
        } else {
            setConfirmButtonClicked(true);
            // setCurrentStep(3);
            navigate('/vehicle/workshop')
        }
    };

    return (
        <div
            className="cart-cont"
            style={{
                background: "white",
                // width: "500px",
                // margin: "100px auto",
                // padding: "20px",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                height: "100%",
                width: "100%"

                // justifyContent: "space-between"/
            }}
        >
            {/* <h2>Services</h2> */}
            <div
                className="cart-sub-cont"
                style={{
                    padding: "10px",
                    // maxWidth: '400px',
                    width: "100%",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "12px",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    height: "100%",
                    // border: "1px solid black",
                }}
            >
                {/* Bootstrap Icons CDN */}

                <div
                    className="service-heading"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "20px",
                        color: "#1976d2",
                        fontSize: "18px",
                        fontWeight: "bold",
                    }}
                >
                    {/* <div
                        className="service-numb"
                        style={{
                            backgroundColor: "#1976d2",
                            color: "white",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "10px",
                        }}
                    >
                        2
                    </div> */}
                    MY SERVICES
                </div>

                <div className="service-bottom-section">
                    <div
                        className="service-list-cont"
                        style={{ maxHeight: window.innerHeight < 800 ? "62vh" : "71vh", overflow: "scroll" }}
                    >
                        {services?.map((service) => {
                            const subServices = getSubServicesForService(
                                service.id
                            );

                            const isExpanded = expandedServices[service.id];
                            const hasSelectedSubServices =
                                servicesWithSelections.includes(service.id);

                            return (
                                <div
                                    className="service-list-sub-cont"
                                    key={service.id}
                                    style={{ marginBottom: "8px" }}
                                >
                                    <div
                                        className="service-lists"
                                        style={{
                                            backgroundColor:
                                                hasSelectedSubServices
                                                    ? "#e3f2fd"
                                                    : "white",
                                            borderRadius: "12px",
                                            padding: "16px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            cursor: "pointer",
                                            boxShadow:
                                                "0 1px 3px rgba(0,0,0,0.1)",
                                            transition:
                                                "all 0.2s ease, box-shadow 0.2s ease",
                                            // ':hover': {
                                            //     boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                                            // }
                                        }}
                                        onClick={() =>
                                            toggleService(service.id)
                                        }
                                    >
                                        <div
                                            className="service-list-names"
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                flex: 1,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    backgroundColor:
                                                        hasSelectedSubServices
                                                            ? "#1976d2"
                                                            : "#ffebcd",
                                                    borderRadius: "50%",
                                                    width: "40px",
                                                    height: "40px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    marginRight: "12px",
                                                    color: hasSelectedSubServices
                                                        ? "white"
                                                        : "#ff6b35",
                                                    transition: "all 0.3s ease",
                                                }}
                                            >
                                                {hasSelectedSubServices ? (
                                                    <i
                                                        className="bi bi-check-circle-fill"
                                                        style={{
                                                            fontSize: "20px",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <i
                                                        className={service.icon}
                                                        style={{
                                                            fontSize: "18px",
                                                        }}
                                                    ></i>
                                                )}
                                            </div>

                                            <div
                                                className="service-list-actual-name"
                                                style={{
                                                    fontWeight: "500",
                                                    fontSize: "14px",
                                                    color: hasSelectedSubServices
                                                        ? "#1976d2"
                                                        : "#666",
                                                    textTransform: "uppercase",
                                                    letterSpacing: "0.5px",
                                                }}
                                            >
                                                {service.name}
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                            }}
                                        >
                                            {subServices.length > 0 && (
                                                <span
                                                    style={{
                                                        backgroundColor:
                                                            "#e3f2fd",
                                                        color: "#1976d2",
                                                        padding: "2px 8px",
                                                        borderRadius: "12px",
                                                        fontSize: "11px",
                                                        fontWeight: "500",
                                                        fontFamily:
                                                            "Atlassian Sans Ext",
                                                    }}
                                                >
                                                    {subServices.length}
                                                </span>
                                            )}

                                            <i
                                                className={`bi ${
                                                    isExpanded
                                                        ? "bi-chevron-down"
                                                        : "bi-chevron-right"
                                                }`}
                                                style={{
                                                    fontSize: "14px",
                                                    color: "#999",
                                                }}
                                            ></i>
                                        </div>
                                    </div>

                                    {/* Sub-services section */}
                                    <div className="sub-service-cont"
                                        style={{
                                            maxHeight: isExpanded
                                                ? "500px"
                                                : "0",
                                            overflow: "hidden",
                                            transition:
                                                "max-height 0.3s ease-in-out, opacity 0.3s ease-in-out, margin-top 0.3s ease-in-out",
                                            opacity: isExpanded ? 1 : 0,
                                            marginTop: isExpanded ? "8px" : "0",
                                        }}
                                    >
                                        <div className="sub-service-sub-cont"
                                            style={{
                                                backgroundColor: "white",
                                                borderRadius: "12px",
                                                padding: "16px",
                                                marginLeft: "8px",
                                                marginRight: "8px",
                                                boxShadow:
                                                    "0 1px 3px rgba(0,0,0,0.05)",
                                                transform: isExpanded
                                                    ? "translateY(0)"
                                                    : "translateY(-10px)",
                                                transition:
                                                    "transform 0.3s ease-in-out",
                                            }}
                                        >
                                            {subServices.length > 0 ? (
                                                <div className="sub-sub-service-name-cont">
                                                    <div className="sub-service-heading"
                                                        style={{
                                                            color: "#666",
                                                            marginBottom:
                                                                "12px",
                                                            textTransform:
                                                                "uppercase",
                                                            letterSpacing:
                                                                "0.5px",
                                                        }}
                                                    >
                                                        Select Sub-Services:
                                                    </div>

                                                    {subServices.map(
                                                        (subService, index) => (
                                                            <div className="sub-service-names"
                                                                key={
                                                                    subService.id
                                                                }
                                                                style={{
                                                                    display:
                                                                        "flex",
                                                                    alignItems:
                                                                        "center",
                                                                    padding:
                                                                        "8px 0",
                                                                    borderBottom:
                                                                        "1px solid #f0f0f0",
                                                                    cursor: "pointer",
                                                                    opacity:
                                                                        isExpanded
                                                                            ? 1
                                                                            : 0,
                                                                    transform:
                                                                        isExpanded
                                                                            ? "translateX(0)"
                                                                            : "translateX(-20px)",
                                                                    transition: `opacity 0.4s ease-in-out ${
                                                                        index *
                                                                        0.1
                                                                    }s, transform 0.4s ease-in-out ${
                                                                        index *
                                                                        0.1
                                                                    }s`,
                                                                }}
                                                                onClick={() =>
                                                                    toggleSubService(
                                                                        subService
                                                                    )
                                                                }
                                                            >
                                                                <div 
                                                                    style={{
                                                                        width: "18px",
                                                                        height: "18px",
                                                                        borderRadius:
                                                                            "3px",
                                                                        border: "2px solid #ddd",
                                                                        marginRight:
                                                                            "12px",
                                                                        display:
                                                                            "flex",
                                                                        alignItems:
                                                                            "center",
                                                                        justifyContent:
                                                                            "center",
                                                                        backgroundColor:
                                                                            selectedSubServices.includes(
                                                                                subService.id
                                                                            )
                                                                                ? "#1976d2"
                                                                                : "white",
                                                                        borderColor:
                                                                            selectedSubServices.includes(
                                                                                subService.id
                                                                            )
                                                                                ? "#1976d2"
                                                                                : "#ddd",
                                                                        transition:
                                                                            "all 0.2s ease-in-out",
                                                                        fontFamily:
                                                                            "Atlassian Sans Ext",
                                                                    }}
                                                                >
                                                                    {selectedSubServices.includes(
                                                                        subService.id
                                                                    ) && (
                                                                        <i
                                                                            className="bi bi-check"
                                                                            style={{
                                                                                color: "white",
                                                                                fontSize:
                                                                                    "12px",
                                                                                opacity:
                                                                                    selectedSubServices.includes(
                                                                                        subService.id
                                                                                    )
                                                                                        ? 1
                                                                                        : 0,
                                                                                transform:
                                                                                    selectedSubServices.includes(
                                                                                        subService.id
                                                                                    )
                                                                                        ? "scale(1)"
                                                                                        : "scale(0)",
                                                                                transition:
                                                                                    "opacity 0.2s ease-in-out, transform 0.2s ease-in-out",
                                                                            }}
                                                                        ></i>
                                                                    )}
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        flex: 1,
                                                                    }}
                                                                >
                                                                    <div 
                                                                    className="sub-service-name-div"
                                                                        style={{
                                                                            fontWeight:
                                                                                "500",
                                                                            fontSize:
                                                                                "14px",
                                                                            color: "#333",
                                                                            marginBottom:
                                                                                "2px",
                                                                      
                                                                        }}
                                                                    >
                                                                        {
                                                                            subService.name
                                                                        }
                                                                    </div>

                                                                    {subService.description && (
                                                                        <div
                                                                            style={{
                                                                                fontSize:
                                                                                    "12px",
                                                                                color: "#666",
                                                                                fontFamily:
                                                                                    "Atlassian Sans Ext",
                                                                            }}
                                                                        >
                                                                            {
                                                                                subService.description
                                                                            }
                                                                        </div>
                                                                    )}

                                                                    {subService.service_hours && (
                                                                        <div
                                                                            style={{
                                                                                fontSize:
                                                                                    "11px",
                                                                                color: "#999",
                                                                                marginTop:
                                                                                    "2px",
                                                                                fontFamily:
                                                                                    "Atlassian Sans Ext",
                                                                            }}
                                                                        >
                                                                            {
                                                                                subService.service_hours
                                                                            }{" "}
                                                                            hour
                                                                            {subService.service_hours !==
                                                                            1
                                                                                ? "s"
                                                                                : ""}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            ) : (
                                                <div
                                                    style={{
                                                        textAlign: "center",
                                                        color: "#999",
                                                        fontSize: "14px",
                                                        fontStyle: "italic",
                                                        padding: "12px 0",
                                                        opacity: isExpanded
                                                            ? 1
                                                            : 0,
                                                        transform: isExpanded
                                                            ? "translateY(0)"
                                                            : "translateY(-10px)",
                                                        transition:
                                                            "opacity 0.4s ease-in-out 0.2s, transform 0.4s ease-in-out 0.2s",
                                                    }}
                                                >
                                                    No sub-services available
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* Confirm Button */}
                    <div style={{ textAlign: "center" }}>
                        <button
                            style={{
                                backgroundColor: selectedSubServices.length
                                    ? "#ff6600"
                                    : "#666",
                                color: "white",
                                border: "none",
                                borderRadius: "25px",
                                padding: "12px 30px",
                                fontSize: "14px",
                                fontWeight: "500",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                                margin: "0 auto",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                fontFamily: "Karbon-medium",
                            }}
                            onClick={nextButtonHandler}

                            // onClick={() => {
                            //     console.log('Selected sub-services:', selectedSubServices);
                            //     alert(`Selected ${selectedSubServices.length} sub-services`);
                            // }}
                        >
                            CONFIRM
                            <i className="bi bi-chevron-right"></i>
                        </button>
                    </div>
                </div>

                {/* Debug info */}
                {/* {selectedSubServices.length > 0 && (
                <div style={{
                    marginTop: '16px',
                    padding: '12px',
                    backgroundColor: '#e8f5e8',
                    borderRadius: '8px',
                    fontSize: '12px',
                    color: '#2e7d32'
                }}>
                    <strong>Selected Sub-Services:</strong> {selectedSubServices.join(', ')}
                </div>
            )} */}
            </div>

            {/* )} */}
        </div>
    );
};

export default Cart;
